import React from 'react';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import WarningIcon from 'components/icon/warning-icon';
import styles from './style.module.scss';

export default function EmptyState({ message }: { message?: string | JSX.Element }) {
  const { t } = useTranslation(Namespaces.COMMON);
  
  const defaultMessage = t(LOCALE_COMMON_PATHS.EMPTY_STATE_DEFAULT_MESSAGE, {
    defaultValue: 'No Results',
  });

  return (
    <div className={styles.component}>
      <WarningIcon/>
      <div className={styles.message}>
        {message ?? defaultMessage}
      </div>
    </div>
  );
}
